// Centralized icon registry using Lucide Vue Next
import {
  // Navigation & UI
  Menu,
  X,
  ChevronDown,
  ChevronUp,
  ChevronLeft,
  ChevronRight,
  ArrowLeft,
  ArrowRight,
  Plus,
  Minus,
  Search,
  Filter,
  SortAsc,
  SortDesc,
  ScrollText,

  // Location & Travel
  MapPin,
  Navigation,
  Compass,
  Globe,
  Earth,
  Plane,
  Car,
  Train,

  // User & Social
  User,
  Users,
  CircleUserRound,
  PersonStanding,
  UserRoundCog,
  Heart,
  Share2,
  Eye,
  MessageCircle,

  // Time & Calendar
  Calendar,
  Clock,
  CalendarDays,

  // Rating & Feedback
  Star,
  StarHalf,
  Award,
  Flame,
  ThumbsUp,

  // Forms & Input
  Mail,
  Phone,
  Lock,
  EyeOff,
  Check,
  AlertCircle,
  Info,

  // Links
  Link,

  // Actions
  Edit,
  Trash2,
  Download,
  Upload,
  Copy,
  Save,
  ExternalLink,
  Pencil,

  // Status & Alerts
  CheckCircle,
  XCircle,
  AlertTriangle,
  Loader2,
  CircleCheck,
  BellRing,

  // Nature & Activities
  Mountain,
  Trees,
  Waves,
  Sun,
  Moon,
  Leaf,
  Zap,
  Building2,
  Users2,
  Sparkles,
  PartyPopper,

  // Activity-specific icons
  Bike,
  Fish,
  Tent,
  Footprints,
  Binoculars,
  Compass as CompassIcon,
  Anchor,
  Sailboat,

  // Entertainment & Leisure
  CircleDot,
  Volleyball,
  ShoppingBag,

  // Weather Icons
  Cloud,
  CloudRain,
  Snowflake,
  CloudSun,
  Wind,

  // Accommodation & Services
  Home,
  Building,
  BedDouble,
  Wifi,
  Car as ParkingIcon,
  Utensils,
  Coffee,

  // Miscellaneous
  Camera,
  Image,
  Play,
  Pause,
  PauseCircle,
  Volume2,
  Settings,
  HelpCircle,
  ShieldAlert,
  Code,
  Hash,

  // Travel specific
  Luggage,
  Ticket,
  CreditCard,
  DollarSign,
  Calculator,
  TrendingUp,
  Banknote,
  Coins,
  Gem,
  PiggyBank,
  FlaskConical,

  // Subscription tiers
  Feather,
  Shell,
  Wand2,
  Briefcase,
  BadgeCheck,

  // Pets & Family
  PawPrint,
  Baby,

  // Accessibility
  Accessibility,

  // View & Layout
  Map,
  List,
  MapPlus,
  BookOpenText,
  MessageSquareShare,

  // Targets & Indicators
  Target,

  // Controls
  SlidersVertical,

} from 'lucide-vue-next'

// Icon registry mapping names to components
export const iconRegistry = {
  // Navigation & UI
  'menu': Menu,
  'x': X,
  'close': X,
  'chevron-down': ChevronDown,
  'chevron-up': ChevronUp,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'plus': Plus,
  'minus': Minus,
  'search': Search,
  'filter': Filter,
  'sort-asc': SortAsc,
  'sort-desc': SortDesc,
  'scroll-text': ScrollText,
  'overview': ScrollText,

  // Location & Travel
  'map-pin': MapPin,
  'location': MapPin,
  'pin': MapPin,
  'navigation': Navigation,
  'compass': Compass,
  'globe': Globe,
  'earth': Earth,
  'plane': Plane,
  'car': Car,
  'train': Train,

  // User & Social
  'user': User,
  'user-circle': CircleUserRound,
  'users': Users,
  'person-standing': PersonStanding,
  'user-round-cog': UserRoundCog,
  'crowd': PersonStanding,
  'heart': Heart,
  'share': Share2,
  'eye': Eye,
  'view': Eye,
  'message': MessageCircle,

  // Time & Calendar
  'calendar': Calendar,
  'clock': Clock,
  'time': Clock,
  'calendar-days': CalendarDays,

  // Rating & Feedback
  'star': Star,
  'star-half': StarHalf,
  'rating': Star,
  'award': Award,
  'rewards': Award,
  'flame': Flame,
  'thumbs-up': ThumbsUp,

  // Forms & Input
  'mail': Mail,
  'email': Mail,
  'phone': Phone,
  'call': Phone,
  'lock': Lock,
  'password': Lock,
  'eye-off': EyeOff,
  'check': Check,
  'alert-circle': AlertCircle,
  'info': Info,

  // Links
  'link': Link,

  // Actions
  'edit': Edit,
  'trash': Trash2,
  'delete': Trash2,
  'download': Download,
  'upload': Upload,
  'copy': Copy,
  'save': Save,
  'external-link': ExternalLink,
  'pencil': Pencil,

  // Status & Alerts
  'check-circle': CheckCircle,
  'success': CheckCircle,
  'circle-check': CircleCheck,
  'x-circle': XCircle,
  'error': XCircle,
  'alert-triangle': AlertTriangle,
  'warning': AlertTriangle,
  'loader': Loader2,
  'loading': Loader2,
  'bell-ring': BellRing,
  'alerts': BellRing,

  // Nature & Activities
  'mountain': Mountain,
  'hiking': Mountain,
  'trees': Trees,
  'nature': Trees,
  'waves': Waves,
  'beach': Waves,
  'sun': Sun,
  'moon': Moon,
  'leaf': Leaf,
  'eco': Leaf,
  'eco-friendly': Leaf,

  // Activity-specific icons
  'swimming': Waves,
  'water-sports': Waves,
  'surfing': Waves,
  'cycling': Bike,
  'biking': Bike,
  'fishing': Fish,
  'camping': Tent,
  'walking': Footprints,
  'binoculars': Binoculars,
  'wildlife': Binoculars,
  'bird-watching': Binoculars,
  'sailing': Sailboat,
  'boating': Anchor,
  'exploring': CompassIcon,

  // Entertainment & Leisure
  'cafes': Coffee,
  'coffee': Coffee,
  'beach-volleyball': Volleyball,
  'volleyball': Volleyball,
  'nightlife': Moon,
  'disco': CircleDot,
  'dancing': CircleDot,
  'shopping': ShoppingBag,
  'shopping-bag': ShoppingBag,

  // Weather Icons
  'summer': Sun,
  'winter': Snowflake,
  'autumn': CloudSun,
  'spring': Cloud,
  'cloud': Cloud,
  'rain': CloudRain,
  'drizzle': CloudRain,
  'thunderstorms': Zap,
  'snow': Snowflake,
  'sunny': Sun,
  'wind': Wind,
  'windy': Wind,
  'lightning': Zap,

  // Accommodation & Services
  'home': Home,
  'building': Building,
  'hotel': Building,
  'bed-double': BedDouble,
  'accommodation': BedDouble,
  'wifi': Wifi,
  'parking': ParkingIcon,
  'utensils': Utensils,
  'restaurant': Utensils,
  'coffee': Coffee,

  // Miscellaneous
  'camera': Camera,
  'image': Image,
  'photo': Image,
  'play': Play,
  'pause': Pause,
  'pause-circle': PauseCircle,
  'volume': Volume2,
  'settings': Settings,
  'help': HelpCircle,
  'shield-alert': ShieldAlert,
  'code': Code,
  'hash': Hash,

  // Travel specific
  'luggage': Luggage,
  'ticket': Ticket,
  'credit-card': CreditCard,
  'dollar': DollarSign,
  'money': DollarSign,
  'calculator': Calculator,
  'budget': PiggyBank,
  'flask-conical': FlaskConical,
  'mid-range': Banknote,
  'luxury': Gem,
  'premium': Gem,
  'trending': TrendingUp,
  'trending-up': TrendingUp,
  'banknote': Banknote,
  'banknotes': Banknote,

  // Pets & Family
  'paw': PawPrint,
  'pet': PawPrint,
  'baby': Baby,
  'child': Baby,

  // Accessibility
  'accessibility': Accessibility,

  // View & Layout
  'map': Map,
  'list': List,
  'map-plus': MapPlus,
  'map-add': MapPlus,
  'book-open-text': BookOpenText,
  'message-square-share': MessageSquareShare,

  // Targets & Indicators
  'target': Target,

  // Feature Icons for destination types - using Lucide Vue Next icons
  'adventure': Zap,
  'cultural': Building2,
  'nature': Trees,
  'wellness': Sparkles,
  'family': Users2,
  'relaxing': Moon,
  'eco-friendly': Leaf,
  'macumba': Sparkles,
  'party': PartyPopper,
  'relaxation': Moon,
  'romantic': Heart,
  'family-friendly': Users2,

  // Subscription tier icons
  'sparkles': Sparkles,
  'feather': Feather,
  'shell': Shell,
  'gem': Gem,
  'wand-2': Wand2,
  'briefcase': Briefcase,
  'badge-check': BadgeCheck,
  'subscription': BadgeCheck,

  // Controls
  'sliders-vertical': SlidersVertical,
}

export default iconRegistry
